import { any, contains } from 'ramda';

import { STUDENT, TEACHER, FUNCTIONARY } from '../constants/UserRoles';
import { AUTHORIZED_POSITIONS } from '../config';

/*
 *   `user` is the result of the /users/profile users API call. The users API
 *   constructs the object by merging the results of the /user/getCompleteInfo
 *   and /user/getInfoAndLicenses myz API calls.
 */

/*
 *   Docente / Teacher access rules:
 *   - is confirmed (upgrade_ok 1)
 *   - has either one of the following gruppiDidattici:
 *       - code 117
 *       - code 120
 */
function gruppoDidatticoIsValid(gruppoDidattico) {
    return contains(gruppoDidattico.code, AUTHORIZED_POSITIONS);
}

function getGruppiDidattici(user) {
    return [
        {
            id: user.gruppoDidatticoId,
            code: user.gruppoDidatticoCode,
            descrizione: user.gruppoDidatticoDescr,
            raggruppamento: user.gruppoDidatticoRaggruppamento
        },
        ...(user.gruppiDidatticiSecondari || [])
    ];
}
function docenteHasAccess(user) {
    if (user.upgrade_ok !== 1) {
        return {
            hasAccess: false,
            reason: 'Docente non confermato'
        };
    }
    if (!any(gruppoDidatticoIsValid, getGruppiDidattici(user))) {
        return {
            hasAccess: false,
            reason: 'Docente senza nessuno dei gruppi didattici richiesti'
        };
    }
    return {
        hasAccess: true
    };
}

function studenteHasAccess() {
    return {
        hasAccess: false
    };
}
/**
 * Check if the user funzionario has access to TT
 * @param user the user object
 * @returns {boolean} true if user can access TT, false otherwise
 */
function funzionarioHasAccess(user) {
    if (user) {
        return {
            hasAccess: true
        };
    }
}
/*
 *   User access rules:
 *   - is confirmed (mail_ok 1)
 *   - has either one of the following roles:
 *       - Docente / Teacher
 *       - Studente / Student
 *       - Funzionario
 */
function roleIsValid(role) {
    return contains(role, [STUDENT, TEACHER, FUNCTIONARY]);
}
/**
 * Check the routes configuration if contains the user role
 * @param user the user object
 * @param authorizedRoles. An array representing the authorized roles
 * @returns {boolean} true if user can access the page, false otherwise
 */
function userRoleHaveAccessToPage(user, authorizedRoles) {
    return authorizedRoles.indexOf(user.role) >= 0;
}

/**
 * Return true if use can access to the last route of routes array
 * @param user
 * @param authorizedRoles. An array representing the authorized roles
 * @return boolean
 */
export default function userHasAccess(user, authorizedRoles) {
    if (user.mail_ok !== 1) {
        return {
            hasAccess: false,
            reason: 'Utente non confermato'
        };
    }

    if (!roleIsValid(user.role) || !userRoleHaveAccessToPage(user, authorizedRoles)) {
        return {
            hasAccess: false,
            reason: 'Ruolo sbagliato'
        };
    }

    if (user.role === TEACHER) {
        return docenteHasAccess(user);
    }
    if (user.role === STUDENT) {
        return studenteHasAccess(user);
    }
    if (user.role === FUNCTIONARY) {
        return funzionarioHasAccess(user);
    }
}
